var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-empty-activity",
    transform: "translate(-550 -302)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(550 302)",
    fill: "#1a1b43",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3717",
    "data-name": "Group 3717",
    transform: "translate(580 332)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1485",
    "data-name": "Rectangle 1485",
    width: 60,
    height: 60,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(3.024 3.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3717-2",
    "data-name": "Group 3717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M47.754,29.992a1.992,1.992,0,0,0-2.118-.258,19.666,19.666,0,0,1-8.418,1.9,19.833,19.833,0,0,1-19.81-19.81A19.938,19.938,0,0,1,18,7.114,2,2,0,0,0,15.2,4.83a23.8,23.8,0,1,0,33.23,27.186A2.011,2.011,0,0,0,47.754,29.992ZM25.322,46.17A19.789,19.789,0,0,1,13.446,10.536q-.039.648-.038,1.284a23.838,23.838,0,0,0,23.81,23.81,23.4,23.4,0,0,0,5.986-.772A19.729,19.729,0,0,1,25.322,46.17Z",
    transform: "translate(-1.512 1.45)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M31.846,6.239l1.23-1.23a2,2,0,1,0-2.828-2.828l-1.23,1.228-1.23-1.228A2,2,0,0,0,24.96,5.009l1.23,1.23L24.96,7.467A2,2,0,1,0,27.788,10.3l1.23-1.228,1.23,1.228a2,2,0,1,0,2.828-2.828Z",
    transform: "translate(21.35 -1.595)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M33.076,24.181a2,2,0,0,0-2.828,0l-1.23,1.228-1.23-1.228a2,2,0,1,0-2.828,2.828l1.23,1.23-1.23,1.228A2,2,0,1,0,27.788,32.3l1.23-1.228,1.23,1.228a2,2,0,1,0,2.828-2.828l-1.23-1.228,1.23-1.23A2,2,0,0,0,33.076,24.181Z",
    transform: "translate(21.35 20.405)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M14.96,16.3a2,2,0,0,0,2.828,0l1.23-1.228,1.23,1.228a2,2,0,1,0,2.828-2.828l-1.23-1.228,1.23-1.23a2,2,0,0,0-2.828-2.828l-1.23,1.228-1.23-1.228a2,2,0,1,0-2.828,2.828l1.23,1.23-1.23,1.228A2,2,0,0,0,14.96,16.3Z",
    transform: "translate(11.35 4.405)",
    fill: "#1a1b43"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyActivity);
export default __webpack_public_path__ + "static/media/icon-empty-activity.592c272eb4c61ff4286e194f5bced06b.svg";
export { ForwardRef as ReactComponent };